import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import { transformResultsFromObjectSplitByVendor } from 'util/data';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE} from 'util/constants';

const
    name = 'awsRegions',
    exports = storeModuleFactory({
        name,
        endpoint:           endpoints.awsRegions.endpoint,
        timeout:            TIMEOUT_STORE.TIMEOUT_STORE_BIG,
        instanceEndpoint:   endpoints.awsRegions.instanceEndpoint,
        transformResultsFn: json => transformResultsFromObjectSplitByVendor(json.results, 'AWS').map(item => ({
            ...item,
            fullLabel: `${item.title} [${item.code}]`
        }))
    });

module.exports = exports;



// WEBPACK FOOTER //
// ./src/modules/store/awsRegions.js